<template>
  <el-form
    ref="form"
    :model="$props.user"
    label-position="top"
    :rules="rules"
  >
    <el-row :gutter="15">
      <el-col :span="12">
        <el-form-item
          label="Full Name"
          prop="name_full"
        >
          <el-input
            v-model="user.name_full"
            placeholder="Full Name"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Display Name"
        >
          <el-input
            v-model="user.name_display"
            placeholder="Display Name"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="12">
        <el-form-item
          label="Time Zone"
          prop="time_zone"
        >
          <el-select
            v-model="user.time_zone"
            filterable
            remote
            clearable
            placeholder="Select"
            :remote-method="searchTimeZone"
            value-key="id"
            :loading="isLoading"
            class="w-100"
          >
            <el-option
              v-for="item in timezones"
              :key="item.id"
              :label="item.zone"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          label="Sign In Type"
          prop="sso_only"
        >
          <el-switch
            v-model="user.sso_only"
            active-text="SSO"
            inactive-text="OpenFreight"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          label="Application"
          prop="application"
        >
          <el-switch
            v-model="isUsingOpen360Authentication"
            active-text="Open360"
            inactive-text="OpenFreight"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="12">
        <el-form-item
          label="Email"
          prop="email"
        >
          <el-input
            v-model="user.email"
            placeholder="Email"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Position"
        >
          <el-input
            v-model="user.position"
            placeholder="Position"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="12">
        <el-form-item
          label="Primary Phone"
          prop="phone_primary"
        >
          <el-input
            v-model="user.phone_primary"
            placeholder="Primary Phone"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Secondary Phone"
        >
          <el-input
            v-model="user.phone_secondary"
            placeholder="Secondary Phone"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="12">
        <el-form-item
          label="Application ID"
        >
          <el-input
            v-model="user.firebase_id"
            readonly
            disabled
            number
            placeholder="Application ID"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="FreshDesk ID"
        >
          <el-input
            v-model="user.freshworks_id"
            placeholder="Freshdesk ID"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  props: {
    // @type Profile.js
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isUsingOpen360Authentication: false,
      // UX
      isLoading: false,
      // data array
      timezones: [],

      // rules
      rules: {
        name_display: [{
          required: true, message: 'Display Name is required', trigger: 'blur'
        }],
        name_full: [{
          required: true, message: 'Full Name is required', trigger: 'blur'
        }],
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' }
        ],
        phone_primary: [
          { required: true, message: 'Primary Phone Number is required', trigger: 'blur' }
        ],
        time_zone: [
          { required: true, message: 'Time Zone is required', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    hasSetFirebase () {
      return this.user.firebase_id !== null && this.user.firebase_id !== undefined
    }
  },
  watch: {
    'isUsingOpen360Authentication': function (newValue) {
      if (newValue) {
        this.user.firebase_id = 'open360'
      } else {
        this.user.firebase_id = null
      }
    }
  },
  methods: {
    searchTimeZone: debounce(function (query) {
    // load time zone
      this.isLoading = true
      this.$sdk.timezone.list((builder) => {
        builder.filters = { timezone: query }
      })
        .then(res => {
          this.timezones = res
        })
        .finally(() => { this.isLoading = false })
    }, 500),
    validate (callback) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          callback()
        }
      })
    }
  }
}
</script>

<style>

</style>
